var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16675 7.5135V6.48683C1.16675 5.88017 1.66258 5.3785 2.27508 5.3785C3.33091 5.3785 3.76258 4.63183 3.23175 3.716C2.92841 3.191 3.10925 2.5085 3.64008 2.20517L4.64925 1.62767C5.11008 1.3535 5.70508 1.51683 5.97925 1.97767L6.04341 2.0885C6.56841 3.00433 7.43175 3.00433 7.96258 2.0885L8.02675 1.97767C8.30091 1.51683 8.89591 1.3535 9.35675 1.62767L10.3659 2.20517C10.8967 2.5085 11.0776 3.191 10.7742 3.716C10.2434 4.63183 10.6751 5.3785 11.7309 5.3785C12.3376 5.3785 12.8392 5.87433 12.8392 6.48683V7.5135C12.8392 8.12017 12.3434 8.62183 11.7309 8.62183C10.6751 8.62183 10.2434 9.3685 10.7742 10.2843C11.0776 10.8152 10.8967 11.4918 10.3659 11.7952L9.35675 12.3727C8.89591 12.6468 8.30091 12.4835 8.02675 12.0227L7.96258 11.9118C7.43758 10.996 6.57425 10.996 6.04341 11.9118L5.97925 12.0227C5.70508 12.4835 5.11008 12.6468 4.64925 12.3727L3.64008 11.7952C3.10925 11.4918 2.92841 10.8093 3.23175 10.2843C3.76258 9.3685 3.33091 8.62183 2.27508 8.62183C1.66258 8.62183 1.16675 8.12017 1.16675 7.5135Z",
    stroke: "#475467",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.d858ae81b61b64c7e9cc1fca1b4422d7.svg";
export { ForwardRef as ReactComponent };